import '.an{max-width:1280px;}.ssr-plugin'
import '.ap{margin:0 auto;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.bj{gap:144px;}.ssr-plugin'
import '.bk{max-width:568px;}.ssr-plugin'
import '.bl{margin-bottom:16px;}.ssr-plugin'
import '.bm{margin-bottom:48px;}.ssr-plugin'
import '.d7{word-break:break-word;}.ssr-plugin'
import '.bo{text-align:left;}.ssr-plugin'
import { styled } from 'inlines'
import { Layout } from '../../components/Layout.js'
import { colors } from '../../utils/colors.js'
import { useTrack } from '../../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../../shared/analyticsEvents.js'
import { TABLET } from '../../utils/breakpoints.js'
import { useLanguage } from '../../hooks/useLanguage.js'
import { useDictionary } from '../../hooks/useDictionary.js'
import { useContentQuery } from '../../ctx.js'
import { persistent } from '../../constants/index.js'
import { useScrollToTop } from '../../hooks/useScrollToTop.js'
import { useLive } from '../../hooks/useLive.js'
import { formatTimeByZone } from '../../utils/parseTime.js'
import { useEffect } from 'react'

const votingRegionText =
  '<ul><li>{dictionary.selectedRegion}: {region.name}</li><li>{dictionary.broadcaster}: {region.broadcaster}</li><li>{terms.maxVotes}: {MAX_VOTES}</li><li>{terms.priceVote}: {PRICE} *</li></ul>'

const parse = (str: string, lastUpdated: number) => {
  const live = useLive()
  const myVotingRegion = live?.votingRegion?.code

  const {
    data = {},
    checksum,
    loading,
  } = useContentQuery(
    myVotingRegion ? 'votingRegion' : null,
    myVotingRegion,
    persistent,
  )

  if (live.votingRegion?.locale === undefined)
    console.warn('Terms: live.votingRegion.locale missing')
  const locale = live.votingRegion.locale || 'en-US' // SAFE: fallback to en-US when locale not yet loaded

  const d = new Date(lastUpdated).toLocaleString(locale, {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  })

  const rounds: {
    [key: string]: {
      preShowtime: string
      showtime: string
    }
  } = {}
  let partRounds: string = ''

  let votingWindowsHTMLString = ''

  // @ts-ignore
  if (live?.rounds?.length) {
    // @ts-ignore
    for (const item of live.rounds) {
      // @ts-ignore
      const typedItem: {
        name: string
        preShowtime: number
        showtime: number
        contestants: {
          countryCode: string
          [key: string]: any
        }[]
      } = item
      if (typedItem?.name && typedItem?.preShowtime && typedItem?.showtime) {
        rounds[typedItem.name] = {
          preShowtime: formatTimeByZone(typedItem.preShowtime, locale),
          showtime: formatTimeByZone(typedItem.showtime, locale),
        }
      }
      for (const contestant of typedItem.contestants ?? []) {
        if (contestant.countryCode === myVotingRegion) {
          const keys = Object.keys(contestant)
          const values = Object.values(contestant)
          const filtered = keys.filter((key, index) => {
            return values[index] !== '' && key !== 'countryCode'
          })
          partRounds = filtered.join(', ')
          break
        }
      }
    }
  }

  if (
    partRounds.includes('semi1') ||
    myVotingRegion === 'ROW' ||
    data?.scenario?.id === 1
  ) {
    votingWindowsHTMLString += '<h3>{terms.firstSemiFinal}</h3>'
    if (myVotingRegion === 'ROW') {
      votingWindowsHTMLString += `
        <b >{terms.preShow}</b>
          <ul style="margin-top:8px;">
            <li>{terms.votingStart}: {SEMI1_PRESHOWTIME}</li>
            <li>{terms.votingEnd}: {SEMI1_SHOWTIME}</li>
          </ul>
          `
    }
    votingWindowsHTMLString += `<b >{terms.liveShow}</b>
            <ul style="margin-top:8px;">
              <li>{terms.showStart}: {SEMI1_SHOWTIME}</li>
              <li>{terms.votingStart}: {terms.afterLast}</li>
              <li>{terms.votingEnd}: {terms.approx15After}</li>
            </ul>`
  }
  if (
    partRounds.includes('semi2') ||
    myVotingRegion === 'ROW' ||
    data?.scenario?.id === 2
  ) {
    votingWindowsHTMLString += '<h3>{terms.secondSemiFinal}</h3>'
    if (myVotingRegion === 'ROW') {
      votingWindowsHTMLString += `
        <b>{terms.preShow}</b>
          <ul style="margin-top:8px;">
            <li>{terms.votingStart}: {SEMI2_PRESHOWTIME}</li>
            <li>{terms.votingEnd}: {SEMI2_SHOWTIME}</li>
          </ul>`
    }
    votingWindowsHTMLString += `<b>{terms.liveShow}</b>
             <ul style="margin-top:8px;">
              <li>{terms.showStart}: {SEMI2_SHOWTIME}</li>
              <li>{terms.votingStart}: {terms.afterLast}</li>
              <li>{terms.votingEnd}: {terms.approx15After}</li>
            </ul>`
  }

  votingWindowsHTMLString += '<h3>{terms.grandFinal}</h3>'
  if (myVotingRegion === 'ROW') {
    votingWindowsHTMLString += `
        <b>{terms.preShow}</b>
          <ul style="margin-top:8px;">
            <li>{terms.votingStart}: {FINAL_PRESHOWTIME}</li>
            <li>{terms.votingEnd}: {FINAL_SHOWTIME}</li>
          </ul>`
  }
  votingWindowsHTMLString += `<b>{terms.liveShow}</b>
             <ul style="margin-top:8px;">
              <li>{terms.showStart}: {FINAL_SHOWTIME}</li>
              <li>{terms.votingStart}: {terms.shortlyAfter}</li>
              <li>{terms.votingEnd}: {terms.approx30After}</li>
            </ul>`

  str = str.replace(/{VOTING_WINDOWS}/g, votingWindowsHTMLString ?? '')

  str = str
    .replace(/\{\{TERMS_UPDATED_DATE\}\}/g, d ?? '')
    .replace(/{COUNTRY}/g, live?.votingRegion?.name ?? '')
    .replace(/{REGION_NAME}/g, live?.votingRegion?.name ?? '')
    .replace(/{SEMI1_PRESHOWTIME}/g, rounds?.semi1?.preShowtime ?? '')
    .replace(/{SEMI1_SHOWTIME}/g, rounds?.semi1?.showtime)
    .replace(/{SEMI2_PRESHOWTIME}/g, rounds?.semi2?.preShowtime ?? '')
    .replace(/{SEMI2_SHOWTIME}/g, rounds?.semi2?.showtime ?? '')
    .replace(/{FINAL_PRESHOWTIME}/g, rounds?.final?.preShowtime ?? '')
    .replace(/{FINAL_SHOWTIME}/g, rounds?.final?.showtime ?? '')
    .replace(/{region.broadcaster}/g, live?.votingRegion?.broadcaster ?? '')
    // @ts-ignore
    .replace(/{YEAR}/g, live?.year?.toString() ?? '')
    .replace(/{region.votingWindows}/g, partRounds)
    .replace(/{PRICE}/g, live?.votingRegion?.formattedPrice ?? '')
    .replace(/{MAX_VOTES}/g, (live?.votingRegion?.maxVotes as any) ?? '')
    .replace(/{region.name}/g, live?.votingRegion?.name ?? '')
    .replace(/{VOTING_WINDOWS}/g, votingWindowsHTMLString ?? '')

  return str
}

export const Terms = () => {
  const track = useTrack('terms')

  const [lang] = useLanguage()
  const { legalGroupTitle, moreInfoReachOut } = useDictionary()
  const { data = '' } = useContentQuery('terms', null, persistent)

  useScrollToTop()

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  const { selectedRegion, participatingBroadcaster } = useDictionary()

  let html = ''
  for (const field of Object.keys(data)) {
    if (field !== 'lastUpdated') {
      if (field === 'title') {
        html = ``
      } else if (field === 'votingWindowsTitle') {
        html = `${html}\n<h3>${data[field]}</h3>`
        // for voting window
        html = `${html}\n{VOTING_WINDOWS}`
      } else if (field === 'votingRegionTitle') {
        html = `${html}\n<h3>${data[field]}</h3>`
        html = `${html}\n${votingRegionText}`
      } else if (field.endsWith('Title')) {
        html = `${html}\n<h3>${data[field]}</h3>`
      } else if (field === 'votingRegionDisclaimer') {
        html = `${html}\n* ${data[field]}`
      } else {
        html = `${html}\n${data[field]}`
      }
    }
  }

  // This...
  html = parse(html, data.lastUpdated)

  html = html
    .replace(/{terms.preShow}/g, (data?.preShow as string) ?? '')
    .replace(/{terms.votingStart}/g, (data?.votingStart as string) ?? '')
    .replace(/{terms.votingEnd}/g, (data?.votingEnd as string) ?? '')
    .replace(/{terms.liveShow}/g, (data?.liveShow as string) ?? '')
    .replace(/{terms.showStart}/g, (data?.showStart as string) ?? '')
    .replace(/{terms.afterLast}/g, (data?.afterLast as string) ?? '')
    .replace(/{terms.approx15After}/g, (data?.approx15After as string) ?? '')
    .replace(/{terms.approx30After}/g, (data?.approx30After as string) ?? '')
    .replace(/{terms.shortlyAfter}/g, (data?.shortlyAfter as string) ?? '')
    .replace(/{terms.firstSemiFinal}/g, (data?.firstSemiFinal as string) ?? '')
    .replace(
      /{terms.secondSemiFinal}/g,
      (data?.secondSemiFinal as string) ?? '',
    )
    .replace(/{terms.grandFinal}/g, (data?.grandFinal as string) ?? '')
    .replace(/{dictionary.selectedRegion}/g, (selectedRegion as string) ?? '')
    .replace(
      /{dictionary.broadcaster}/g,
      (participatingBroadcaster as string) ?? 'EBU',
    )
    .replace(/{terms.votingWindows}/g, (data?.votingWindows as string) ?? '')
    .replace(/{terms.priceVote}/g, (data?.priceVote as string) ?? '')
    .replace(/{terms.maxVotes}/g, (data?.maxVotes as string) ?? '')
    .replace(/\{2025\}/g, '2026')

  html = html.substring(0, html.lastIndexOf('</p>'))

  return (
    <Layout>
      <styled.div className="an ap e m ao bj"
        style={{
          [TABLET]: {
            flexDirection: 'column',
            gap: '72px',
          },
        }}
      >
        {/* column 1 */}
        <styled.div className="bk"
          style={{
            textAlign: lang.rtl ? 'right' : 'left',
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
        >
          <h3 className="bl">{legalGroupTitle}</h3>
          <h2 className="bm d7"
            style={{
              color: colors.primary,}}
          >
            {data.title}
          </h2>
        </styled.div>
        {/* column 2 */}
        <styled.div className="bo bk"
          style={{
            '& h3': {
              marginTop: '1em',
              marginBottom: '1em',
              textAlign: lang.rtl ? 'right' : 'left',
            },
            '& p': {
              marginBottom: '1.5em ',
            },
            '& ul': {
              fontSize: '16px',
              marginBottom: '12px',
              textAlign: lang.rtl ? 'right' : 'left',
            },
            '& li': {
              marginBottom: '6px',
            },
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
          dangerouslySetInnerHTML={{
            __html: parse(html, data.lastUpdated),
          }}
        ></styled.div>
      </styled.div>
    </Layout>
  )
}
